<!--
    课程分享-课时编辑-课时分类（弹窗）
    作用：新增分类组件
    功能：新增分类
    说明：版本3.0
-->
<template>
  <el-dialog
    :title="title?title:'提示'"
    :visible.sync="dialogVisible"
    :append-to-body="true"
    :close-on-click-modal="false"
    :before-close="handleClose"
    width="360px">
    <!-- <ElementForm
      ref="form"
      :form="newForm"
      @onAttr="onAttr"
    /> -->
    <!--    <IMUploadMul />-->
    <el-form
      ref="form"
      :model="form"
      :rules="rules">
      <el-form-item
        label="分类名称"
        prop="name">
        <el-input v-model="form.name"/>
      </el-form-item>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button
        type="primary"
        @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'AddGame',
  props: {
    // eslint-disable-next-line vue/require-default-prop
    title: String,
    visible: {
      type: Boolean,
      default: false,
    },
    // eslint-disable-next-line vue/require-default-prop
    defaultValue: Object,
  },
  data() {
    return {
      dialogVisible: this.visible,
      newDefaultValue: this.defaultValue,
      form: {
        name: '',
      },
      rules: {
        name: [
          { required: true, message: '请输入分类名称', trigger: 'blur' },
        ],
      },
    };
  },
  watch: {
    visible(vl) { this.dialogVisible = vl; },
    dialogVisible(vl) {
      this.$emit('update:visible', vl);
    },
    defaultValue(vl) { this.newDefaultValue = vl; },
    newDefaultValue(vl) {
      this.$emit('update:defaultValue', vl);
    },
  },
  created() {
    // 如果是编辑，赋予初始值
    this.$nextTick(() => {
      if (this.newDefaultValue && this.newDefaultValue.isEdit) {
        if (this.newDefaultValue.data.name) {
          this.form.name = this.newDefaultValue.data.name;
        }
      }
    });
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('success', {
            isEdit: this.defaultValue.isEdit,
            name: this.form.name,
          });
          this.handleClose();
        }
      });
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/CourseOn/editClassHours/components/typeSelect/components/typeName/index.vue